import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosInstance';
import { API_URL_All } from '../api';
import axios from 'axios';

import { toast } from "react-toastify";
import * as general from '../libs/general';
import AdminLayout from '../components/AdLayout';


const AdminDashboard = () => {

  const [pageData, setPageData] = useState({ content: [] });
  const [pageMonth, setPageMonth] = useState({ content: [] });

  useEffect(() => {

    searchOrders();
  }, []);

  const searchOrders = async (filter) => {

    if (window.calling) return;
    window.calling = true;


    var response = {};
    try {
      response = await axiosInstance.get('/api/dashboard/getTotalFeeByDayInLast30Days');
      setPageData(response.data);

      response = await axiosInstance.get('/api/dashboard/getTotalFeeByMonthInLast12Months');
      setPageMonth(response.data);

    } catch (error) {

      console.error(error);
    } 

    window.calling = false;
  };

    return (
        <div>
            <AdminLayout>
                <div className="top_nav">
                    <div className="nav_menu">
                        <div className="nav toggle">
                            <a id="menu_toggle"><i className="fa fa-arrow-right"></i><i className="fa fa-arrow-left"></i></a>
                        </div>
                        <div className="main-header">
                            <div className="text-center">HỆ THỐNG ZTO</div>
                        </div>
                    </div>
                </div>
                <div className="right_col" role="main">

            <div className="row">
              <div className="col-md-12 ">
                <div className="x_panel">
                  <div className="x_title">
                    <h2 className="fw-bold">Thông tin hệ thống</h2>
                    <ul className="nav navbar-right panel_toolbox">
                    </ul>
                    <div className="clearfix"></div>
                  </div>
                  <div className="x_content calc-200">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center my-5">Thông tin chung về hệ thông ZTO</div>
                      </div>
                    </div>
                    <div className="row d-none">
                      <div className="col-md-6">
                        <div className="table-s table-normal">
                          <table>
                            <tbody>
                              <tr>
                                <th width="50px">STT</th>
                                <th width="100px">Ngày</th>
                                <th width="100px"><span data-note="">Số đơn hàng</span></th>
                                <th width="100px"><span data-note="">Tổng phí</span></th>
                                <th>Mô tả</th>
                              </tr>
                              {pageData && pageData.items && pageData.items.map((item, index) => (

                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className=""><span>{general.formatDate(item.date)}</span></td>
                                  <td className="text-end"><span>{general.formatNumber(item.orderCount)}</span></td>
                                  <td className="text-end">
                                    {general.formatNumber(item.totalFee)}
                                  </td>
                                  <td className="cell-normal">{general.formatNumber(item.profit)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>


                      <div className="col-md-6">
                        <div className="table-s table-normal">
                          <table>
                            <tbody>
                              <tr>
                                <th width="50px">STT</th>
                                <th width="100px">Tháng</th>
                                <th width="100px"><span data-note="">Số đơn hàng</span></th>
                                <th width="100px"><span data-note="">Tổng phí</span></th>
                                <th>Mô tả</th>
                              </tr>
                              {pageMonth && pageMonth.items && pageMonth.items.map((item, index) => (

                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className=""><span>{item.yearMonth}</span></td>
                                  <td className="text-end"><span>{general.formatNumber(item.orderCount)}</span></td>
                                  <td className="text-end">
                                    {general.formatNumber(item.totalFee)}
                                  </td>
                                  <td className="cell-normal">{general.formatNumber(item.profit)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>


                  </div>
                </div>
              </div>


            </div>
                </div>
                
            </AdminLayout>
        </div>
    );
};

export default AdminDashboard;